import React, {useState} from 'react'

const BarcodeUrlSkipContext = React.createContext()

const BarcodeUrlSkipProvider = ({children}) => {
  const [urlGoTo, setUrlGoTo] = useState('')

  return (
    <BarcodeUrlSkipContext.Provider value={{urlGoTo, setUrlGoTo}}>
      {children}
    </BarcodeUrlSkipContext.Provider>
  )
}

const BarcodeUrlSkipConsumer = BarcodeUrlSkipContext.Consumer

export {BarcodeUrlSkipProvider, BarcodeUrlSkipContext, BarcodeUrlSkipConsumer}
